import type { VoidFunctionComponent } from 'react';

import FileViewerFileContentsContainer from '../../../../shared/revisions/FileViewer/FileContents';
import type { RevisionFileMatch } from '../../../../../hooks/api/revisions/useFileMatchesForRevision';

import styles from './MatchesTab.module.less';

type Props = {
  revisionId: string;
  match: RevisionFileMatch;
};

const MatchPathContent: VoidFunctionComponent<Props> = ({ revisionId, match }) => {
  return (
    <FileViewerFileContentsContainer
      className={styles.codeMirror}
      revisionLocator={revisionId}
      filePath={match.path}
      sources={match.sources}
      isCliLicenseScanWithMatchData={false}
    />
  );
};

export default MatchPathContent;
